import imgDirectivo from "../../../assets/images/equipodirectivo.png";
import imgDocente from "../../../assets/images/equipodocente.png";
import imgAdministrativo from "../../../assets/images/equipoadministrativo.png";
import { Container, Row, Col, Card } from "react-bootstrap";

function Staff() {
  return (
    <Container className="py-4">
      <h1
        className="text-center display-6 mb-4"
        style={{ animation: "ease-in-out", letterSpacing: "4px", color: "#facc15" }}
      >
        Staff
      </h1>

      <p className="lead text-center">
        Nuestro equipo docente en el Colegio Santo Tomás se destaca por su excelente nivel de
        formación y su compromiso con la capacitación continua en los tres niveles educativos.
        Contamos con una Directora, quien, junto a los directores de cada nivel y la
        Administradora General, forma parte del equipo directivo.
      </p>
      <p className="text-center">
        Este equipo trabaja de manera conjunta y constante para mejorar la calidad educativa y
        garantizar una gestión eficiente en nuestra institución. La colaboración y el enfoque en la
        mejora continua son pilares fundamentales de nuestra labor.
      </p>

      <Row className="mt-4 g-4">
        <Col sm={4} className="texto-animado">
          <h5 className="text-center mb-4 display-6">Equipo Directivo</h5>
          <Card className="bg-transparent border-0">
            <Card.Body className="d-flex justify-content-center">
              <Card.Img src={imgDirectivo} style={{ width: "50%" }} alt="Equipo Directivo" />
            </Card.Body>
          </Card>
        </Col>

        <Col sm={4} className="texto-animado">
          <h5 className="text-center mb-4 display-6">Equipo Docente</h5>
          <Card className="bg-transparent border-0">
            <Card.Body className="d-flex justify-content-center">
              <Card.Img src={imgDocente} style={{ width: "50%" }} alt="Equipo Docente" />
            </Card.Body>
          </Card>
        </Col>

        <Col sm={4} className="texto-animado">
          <h5 className="text-center mb-4 display-6">Equipo Administrativo</h5>
          <Card className="bg-transparent border-0">
            <Card.Body className="d-flex justify-content-center">
              <Card.Img src={imgAdministrativo} style={{ width: "50%" }} alt="Equipo Administrativo" />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Staff;
